import { MutationTree, GetterTree } from "vuex";
import store from "store";

const state: any = {
  open_mode_info: {},
  id_card_photo: {},
  id_card_ocr_info: store.get("id_card_ocr_info") || {},
  address_proof_info: {},
  tax_place: { choice: [], extra: [] },
  tax_resident: [],
  w8ben_info: {},
  examine_list: {}, // 适应性调查
  signature_photo: "",
  country_list: {
    hot: [],
    normal: []
  },
  //身份信息填写中的国籍字段temp
  currentCountry: {
    id: "",
    name: ""
  },
  derivative:{}
};

const mutations: MutationTree<any> = {
  SAVE_OPEN_MODE_INFO(state, res): void {
    state.open_mode_info = res;
  },

  SAVE_ID_CARD_PHOTO(state, res): void {
    state.id_card_photo = res;
  },

  SAVE_ID_CARD_OCR_INFO(state, res): void {
    state.id_card_ocr_info = res;
    state.currentCountry = {
      id: res.nationality_code,
      name: res.nationality_name
    };
    store.set("id_card_ocr_info", res);
  },

  SAVE_CURRENT_COUNTRY(state, res): void {
    state.currentCountry = res;
  },

  SAVE_ADDRESS_PROOF_INFO(state, res): void {
    state.address_proof_info = res;
  },

  SAVE_TAX_PLACE_EXTRA(state, res): void {
    state.tax_place.extra = res;
  },

  SAVE_TAX_PLACE(state, res): void {
    state.tax_place = res;
  },

  SAVE_COUNTRY_LIST(state, res): void {
    state.country_list = res;
  },

  SAVE_TAX_RESIDENT(state, res): void {
    state.tax_resident = res;
  },

  SAVE_W8BEN_INFO(state, res): void {
    state.w8ben_info = res;
  },

  SAVE_EXAMINE_LIST(state, res): void {
    state.examine_list = {
      ...state.examine_list,
      ...res
    };
  },

  SAVE_SIGNATURE_PHOTO(state, res): void {
    state.signature_photo = res;
  },

  SAVE_DERIVATIVE(state, res): void {
    state.derivative = res;
  }
};

const getters: GetterTree<any, any> = {
  open_mode_info(state: any): void {
    return state.open_mode_info;
  },
  id_card_photo(state: any): void {
    return state.id_card_photo;
  },
  id_card_ocr_info(state: any): void {
    return state.id_card_ocr_info;
  },
  address_proof_info(state: any): void {
    return state.address_proof_info;
  },
  tax_place(state: any): void {
    return state.tax_place;
  },
  tax_resident(state: any): void {
    return state.tax_resident;
  },
  w8ben_info(state: any): void {
    return state.w8ben_info;
  },
  examine_list(state: any): void {
    return state.examine_list;
  },
  signature_photo(state: any): void {
    return state.signature_photo;
  },
  country_list(state: any): void {
    return state.country_list;
  },
  currentCountry(state: any): void {
    return state.currentCountry;
  },
  derivative_info(state: any): void {
    return state.derivative;
  },
};

export default { namespaced: true, state, mutations, getters };
